import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$: Observable<boolean> = this.loadingSubject.asObservable();

  private loadingFolders = new BehaviorSubject<boolean>(false);
  loadingFolders$: Observable<boolean> = this.loadingFolders.asObservable();

  private loadingFiles = new BehaviorSubject<boolean>(false);
  loadingFiles$: Observable<boolean> = this.loadingFiles.asObservable();

  private loadingRecentToday = new BehaviorSubject<boolean>(false);
  loadingRecentToday$: Observable<boolean> = this.loadingRecentToday.asObservable();

  private loadingRecentYesterday = new BehaviorSubject<boolean>(false);
  loadingRecentYesterday$: Observable<boolean> = this.loadingRecentYesterday.asObservable();

  private loadingRecentWeek = new BehaviorSubject<boolean>(false);
  loadingRecentWeek$: Observable<boolean> = this.loadingRecentWeek.asObservable();

  setLoading(isLoading: boolean): void {
    this.loadingSubject.next(isLoading);
  }

  setLoadingFolders(isLoading: boolean): void {
    this.loadingFolders.next(isLoading);
  }

  setLoadingFiles(isLoading: boolean): void {
    this.loadingFiles.next(isLoading);
  }

  setLoadingRecentToday(isLoading: boolean): void {
    this.loadingRecentToday.next(isLoading);
  }

  setLoadingRecentYesterday(isLoading: boolean): void {
    this.loadingRecentYesterday.next(isLoading);
  }

  setLoadingRecentWeek(isLoading: boolean): void {
    this.loadingRecentWeek.next(isLoading);
  }
}
